import { KEYVALUES_SERVICE } from "@/services/keyValues.service.js";

const state = {postKeyValueOutput: false, getKeyValuesOutput: {}, putKeyValueOutput: false, getKeyValueDetailsOutput: {}, deleteKeyValueByIdOutput: false};

const actions = {
    //Service to create Key Values
    postKeyValue({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postKeyValueRequest');

        KEYVALUES_SERVICE.postKeyValue(input)
            .then(
                output => {
                    commit('postKeyValueSuccess', output);
                },
                error => {
                    commit('postKeyValueFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated Key values
    getKeyValues({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getKeyValuesRequest');

        KEYVALUES_SERVICE.getKeyValues(queryParams)
            .then(
                output => {
                    commit('getKeyValuesSuccess', output);
                },
                error => {
                    commit('getKeyValuesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update key values
    putKeyValue({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putKeyValueRequest');

        KEYVALUES_SERVICE.putKeyValue(input)
            .then(
                output => {
                    commit('putKeyValueSuccess', output);
                },
                error => {
                    commit('putKeyValueFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get key value details
    getKeyValueDetails({ dispatch, commit }, uniqueIdentifier) {
        dispatch('alert/clear', null, { root: true });
        commit('getKeyValueDetailsRequest');

        KEYVALUES_SERVICE.getKeyValueDetails(uniqueIdentifier)
            .then(
                output => {
                    commit('getKeyValueDetailsSuccess', output);
                },
                error => {
                    commit('getKeyValueDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete key values
    deleteKeyValueById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteKeyValueByIdRequest');

        KEYVALUES_SERVICE.deleteKeyValueById(id)
            .then(
                output => {
                    commit('deleteKeyValueByIdSuccess', output);
                },
                error => {
                    commit('deleteKeyValueByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postKeyValue
    postKeyValueRequest(state) {
        state.postKeyValueOutput = null;
    },
    postKeyValueSuccess(state, output) {
        state.postKeyValueOutput = true;
    },
    postKeyValueFailure(state) {
        state.postKeyValueOutput = false;
    },

    //getKeyValues
    getKeyValuesRequest(state) {
    },
    getKeyValuesSuccess(state, output) {
        state.getKeyValuesOutput = output;
    },
    getKeyValuesFailure(state) {
        state.getKeyValuesOutput = false;
    },

    //putKeyValue
    putKeyValueRequest(state) {
        state.putKeyValueOutput = null;
    },
    putKeyValueSuccess(state, output) {
        state.putKeyValueOutput = true;
    },
    putKeyValueFailure(state) {
        state.putKeyValueOutput = false;
    },

    //getKeyValueDetails
    getKeyValueDetailsRequest(state) {
    },
    getKeyValueDetailsSuccess(state, output) {
        state.getKeyValueDetailsOutput = output;
    },
    getKeyValueDetailsFailure(state) {
        state.getKeyValueDetailsOutput = false;
    },

    //deleteKeyValueById
    deleteKeyValueByIdRequest(state) {
        state.deleteKeyValueByIdOutput = null;
    },
    deleteKeyValueByIdSuccess(state, output) {
        state.deleteKeyValueByIdOutput = true;
    },
    deleteKeyValueByIdFailure(state) {
        state.deleteKeyValueByIdOutput = false;
    },
};

export const keyValues = {
    namespaced: true,
    state,
    actions,
    mutations
};